import { useIntl } from 'react-intl';

import { testId } from 'ui-components/services/testid-service';

import { CustomsField } from '../customs-field';
import { CustomsTextInput } from '../customs-text-input';
import messages from '../messages';

type CustomsMidProps = {
  onChange: (newValue: string | number) => void;
  value?: string;
};

export const CustomsMid = ({ onChange, value = '' }: CustomsMidProps) => {
  const intl = useIntl();
  return (
    <CustomsField label={messages.midLabel} recommended>
      <CustomsTextInput
        {...testId('customs-widget-mid-input')}
        aria-label={intl.formatMessage(messages.midLabel)}
        onChange={onChange}
        type='text'
        value={value}
      />
    </CustomsField>
  );
};
